// extracted by mini-css-extract-plugin
export var active = "languagesToggle-module--active--0EABn";
export var container = "languagesToggle-module--container--7rlzN";
export var labelEnglish = "languagesToggle-module--labelEnglish--HJ+rP";
export var labelSpanish = "languagesToggle-module--labelSpanish--StnnK";
export var radioEnglish = "languagesToggle-module--radio-english--gDJ2a";
export var radioSpanish = "languagesToggle-module--radio-spanish--ur2ky";